//general notifications functionality (invites/broadcasts)
const state = {
  // show red dot in sidebar if new notification
  newNotification: false,

  notificationsViewed: [],
};

const getters = {
  // show red dot in sidebar if new notification
  getNewNotification: (state) => state.newNotification,

  getNotificationsViewed: (state) => state.notificationsViewed,
};

const mutations = {
  // show red dot in sidebar if new notification
  setNewNotification(state, data) {
    state.newNotification = data;
  },

  setNotificationsViewed(state, data) {
    state.notificationsViewed = data;
  },
};

const actions = {
  // new notifications -------------------------------------
  async showNewNotification({commit}) {
    commit('setNewNotification', true)
  },
  async clearNewNotification({commit}) {
    commit('setNewNotification', false)
  },
  // show red dot in sidebar if new notification
  async setNewNotification({getters,dispatch}) {
    dispatch('showNewNotification')
    //if opened on sidebar + seen (remove new notification after 2 secs)
    if (getters['sidebar/panelId'] === 'notifications') {
      setTimeout(() => {
        dispatch('clearNewNotification');
      }, 2000);
    }
  },
  checkIfShowNotificationsUpdate({dispatch}, data) {
    let showNew = false

    // PINS
    // let pinTypes = ['pinsCancelled', 'pinsUpdated', 'pinsInvite', 'pinsExpired']
    let updatePinStatuses = ['Offline', 'Unavailable']
    if((data.type === 'pinsUpdated' && updatePinStatuses.includes(data.response)) || data.type === 'pinsExpired') showNew = true

    // ROOM INVITES
    // let inviteTypes = ['roomInvite']
    let receivedStatuses = ['cancelled', 'missed']
    let sentStatuses = ['declined', 'accepted', 'custom']
    if(data.sentOrReceived === 'received' && receivedStatuses.includes(data.status)) showNew = true
    else if(data.sentOrReceived === 'sent' && sentStatuses.includes(data.status)) showNew = true

    if(showNew) dispatch('setNewNotification')
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
